import { styled, themeGet } from '@qwealth/qcore';

interface TextButtonProps {
  isDeleteButton?: boolean;
}

//ToDo: remove when its added to qcore
export const TextButton = styled.button<TextButtonProps>`
  background: none;
  border: none;
  color: ${({ isDeleteButton }) =>
    isDeleteButton ? themeGet('colors.gray.2') : themeGet('colors.primary')};
  font-weight: ${themeGet('fontWeights.large')};
  font-weight: ${themeGet('fontWeights.bold')};

  &:hover {
    color: ${themeGet('colors.primaryLight.1')};
  }
`;
